import {
  BreakpointObserver,
  Breakpoints,
  BreakpointState,
} from '@angular/cdk/layout';
import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ResponsiveService implements OnDestroy {
  private readonly _width$: BehaviorSubject<number> = new BehaviorSubject(
    window.innerWidth
  );
  readonly width$ = this._width$.asObservable();
  smallScreen$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  mediumScreen$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  largeScreen$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  xSmallScreen$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  xLargeScreen$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  subscriptions: Subscription[] = [];

  constructor(private breakpointObserver: BreakpointObserver) {
    window.addEventListener('resize', this.onWidthChanged.bind(this));
    this.initializeObservers();
  }

  private initializeObservers(): void {
    this.subscriptions = [
      ...this.subscriptions,
      // xSmall screen size
      this.breakpointObserver
        .observe(Breakpoints.XSmall)
        .subscribe((result: BreakpointState) => {
          this.xSmallScreen$.next(result.matches);
        }),

      // Small screen size
      this.breakpointObserver
        .observe(Breakpoints.Small)
        .subscribe((result: BreakpointState) => {
          this.smallScreen$.next(result.matches);
        }),

      // Medium screen size
      this.breakpointObserver
        .observe(Breakpoints.Medium)
        .subscribe((result: BreakpointState) => {
          this.mediumScreen$.next(result.matches);
        }),

      // Large screen size
      this.breakpointObserver
        .observe(Breakpoints.Large)
        .subscribe((result: BreakpointState) => {
          this.largeScreen$.next(result.matches);
        }),

      // XLarge screen size
      this.breakpointObserver
        .observe(Breakpoints.XLarge)
        .subscribe((result: BreakpointState) => {
          this.xLargeScreen$.next(result.matches);
        }),
    ];
  }

  onWidthChanged(): void {
    this._width$.next(window.innerWidth);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) =>
      subscription.unsubscribe()
    );
  }
}
